module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Hb-Ia.85a86394.png";